import { fromEntries } from './fromEntries.es.js';

const omit = (obj, keys) => {
  return fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key)));
};

export { omit };
//# sourceMappingURL=omit.es.js.map
